// 認証 API 8 個の TypeScript ラッパー

import { apiFetch } from "./client";

// ---- 共有型 ----

export type RoleCode = "system_admin" | "editor" | "viewer";

export interface AuthenticatedUser {
  id: string;
  email: string;
  name: string;
  roles: RoleCode[];
}

export interface MeUser extends AuthenticatedUser {
  permissions: string[];
}

export interface MeResponse {
  user: MeUser;
  tenant: { id: string; tenant_code: string; company_name: string };
  session: { id: string; trusted: boolean };
}

export type LoginSuccessResponse = {
  status: "authenticated";
  user: AuthenticatedUser;
};

export type LoginChallengeResponse = {
  status: "challenge_required";
  challenge_id: string;
  challenge_type: "email_code";
  expires_in_seconds: number;
  masked_destination: string;
  risk_level: "high" | "critical";
};

export type LoginResponse = LoginSuccessResponse | LoginChallengeResponse;

export interface SessionItem {
  id: string;
  current: boolean;
  device_name: string | null;
  browser_family: string | null;
  os_family: string | null;
  ip: string;
  location: string;
  trusted: boolean;
  last_seen_at: string;
}

// ---- 8 API ----

export const authApi = {
  login: (body: {
    email: string;
    password: string;
    /** @deprecated 2026-08-17〜backend 無視。後方互換のため型だけ残す。 */
    tenant_code?: string;
    device_fingerprint?: string;
    device_name?: string;
  }) =>
    apiFetch<LoginResponse>("/auth/login", {
      method: "POST",
      body: JSON.stringify(body),
    }),

  verifyLogin: (body: {
    challenge_id: string;
    code: string;
    device_fingerprint?: string;
    device_name?: string;
  }) =>
    apiFetch<LoginSuccessResponse>("/auth/verify-login", {
      method: "POST",
      body: JSON.stringify(body),
    }),

  refresh: () =>
    apiFetch<{ status: "refreshed" }>("/auth/refresh", { method: "POST" }),

  logout: () =>
    apiFetch<{ status: "logged_out" }>("/auth/logout", { method: "POST" }),

  logoutAll: () =>
    apiFetch<{ status: "logged_out_all" }>("/auth/logout-all", {
      method: "POST",
    }),

  me: () => apiFetch<MeResponse>("/auth/me"),

  sessions: () =>
    apiFetch<{ items: SessionItem[] }>("/auth/sessions"),

  revokeSession: (sessionId: string) =>
    apiFetch<{ status: "session_revoked" }>(
      `/auth/sessions/${sessionId}`,
      { method: "DELETE" }
    ),

  // 2026-09-19: SettingsPage セルフサービス用パスワード変更
  // tid / uid は JWT cookie から backend 側で自動取得(フロントは送らない)
  changePassword: (body: {
    current_password: string;
    new_password: string;
    new_password_confirm: string;
  }) =>
    apiFetch<{ status: "password_changed"; user: AuthenticatedUser }>(
      "/auth/change-password",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    ),
};